import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef, output, input, computed, HostBinding } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { interval } from 'rxjs';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

import { ConversationType, UserChat } from '@app/modules/message-center/models/chat.model';
import { OnlineStatus } from '@app/modules/message-center/models/user.model';
import { GroupType } from '@app/core/enums';
import { IdNameWidgetResponse } from '@app/models/response.model';
import { ChatGroupingType } from '../enums';

const UPDATE_LAST_SEEN_INTERVAL = 10000;

dayjs.extend(relativeTime);

@UntilDestroy()
@Component({
  selector: 'app-chat-header',
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ChatHeaderComponent implements OnInit {
  chat = input<UserChat>();
  isThread = input<boolean>(false);
  showUnreadMessages = input<boolean>(false);

  groupChatEdit = output<void>();

  avatars = computed<IdNameWidgetResponse[]>(() => {
    const hasImage = !!this.chat()?.image;
    const isGroup = this.chat()?.conversation_type === ConversationType.group;
    const isPrivate = this.chat()?.access_type === GroupType.Private;

    if (hasImage || !isGroup || !isPrivate) {
      return null;
    }

    return (this.chat()?.members ?? []).map(m => ({ id: m.avatar, name: m.short_name }));
  });

  readonly ChatGroupingType = ChatGroupingType;
  readonly ConversationType = ConversationType;
  readonly OnlineStatus = OnlineStatus;
  readonly GroupType = GroupType;

  @HostBinding('class.is-thread') get isThreadClass(): boolean {
    return this.isThread();
  }

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    interval(UPDATE_LAST_SEEN_INTERVAL)
      .pipe(untilDestroyed(this))
      .subscribe(() => this.cdr.markForCheck());
  }

  getTimeAgo(date: string): string {
    return dayjs(date).fromNow();
  }

  editGroupChat(): void {
    this.groupChatEdit.emit();
  }
}
